import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container, Snackbar, Alert, Paper, Fade
} from '@mui/material';
import axios from 'axios';
import BuildingForm from '../components/BuildingForm';

const AddBuilding = () => {
    const navigate = useNavigate();
    const [newBuildingId, setNewBuildingId] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const handleAddBuilding = (payload) => {
        console.log(payload);
        axios.post('/buildings/', payload)
            .then((response) => {
                const createdId = response.data.id;
                setNewBuildingId(createdId);
                setSnackbar({ open: true, message: 'Building added successfully!', severity: 'success' });
            })
            .catch(() => {
                setSnackbar({ open: true, message: 'Error adding building. Please try again.', severity: 'error' });
            });
    };

    return (
        <Container maxWidth="xl" sx={{ my: 5, minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Fade in={true} timeout={800}>
                <Paper elevation={4} sx={{ p: { xs: 2, sm: 2 }, borderRadius: 4, minWidth: { xs: '100%', sm: 500, md: 800, lg: 1000, xl: 1200 }, maxWidth: { md: 800, lg: 1000, xl: 1200 }, mx: 'auto', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BuildingForm
                        initialValues={{
                            name: '',
                            electricity_price: '',
                            gas_price: '',
                            oil_price: '',
                            T_inside_heating: '',
                            daily_hours: '',
                            nightly_hours: '',
                            lat: '',
                            lon: '',
                            budget: '',
                            available_area: ''
                        }}
                        onSubmit={handleAddBuilding}
                        submitLabel="Add"
                        isEdit={false}
                    />
                </Paper>
            </Fade>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => {
                    setSnackbar({ ...snackbar, open: false });
                    if (newBuildingId) {
                        navigate(`/buildings/${newBuildingId}`);
                    }
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Alert
                    onClose={() => {
                        setSnackbar({ ...snackbar, open: false });
                        if (newBuildingId) {
                            navigate(`/buildings/${newBuildingId}`);
                        }
                    }}
                    variant="filled"
                    severity={snackbar.severity}
                    sx={{ width: '100%', mb: 5 }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default AddBuilding;